export default __webpack_public_path__ + "static/media/individual.cf005489.png";